import { messagesRoot } from "./constants";

class GetAttachmentBlobFiles {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  callApi = async (fileUrl) => {
    const apiRoute = messagesRoot + "GetAttachmentFile";
    let params = { fileUrls: fileUrl };
    return await this.apiClass.CallApiSkipErrorHandling(
      "post",
      apiRoute,
      params
    );
  };
}

export default GetAttachmentBlobFiles;
